import Api from '../api/NsPanel';

const emptyState = () => (
    {
        ac: {},
        acTemp: { cool: 0, heat: 0 },
        vent: { reasons: [], period: [] },
        weatherStations: [],
        indoorSensors: [],
        rooms: [],
        weather: { current: null, forecast: null },
        general: {},
    });

const state = {
    nspanel: emptyState(),
    nspanelLoaded: false,
    // server said the caller has no rights to any nspanel
    nspanelDenied: false,
};

const getters = {
    nspanel: (nsState) => nsState.nspanel,
    nspanelLoaded: (nsState) => nsState.nspanelLoaded,
    nspanelDenied: (nsState) => nsState.nspanelDenied,
};

const actions = {
    fetchNsPanel(context)
    {
        Api.getState({}, (data) =>
        {
            if (data && !data.error)
            {
                context.commit('NSPANEL_STATE', data);
                return;
            }

            if (data && String(data.notice || '').indexOf('no_privilage') !== -1)
            {
                context.commit('NSPANEL_DENIED');
            }
        });
    },
};

const mutations = {
    NSPANEL_STATE(nsState, data)
    {
        nsState.nspanel = data;
        nsState.nspanelLoaded = true;
        nsState.nspanelDenied = false;
    },
    NSPANEL_DENIED(nsState)
    {
        nsState.nspanelDenied = true;
    },
    // pushed by the 'nspanel' socket event or returned by an action - hvac part only
    NSPANEL_HVAC(nsState, data)
    {
        nsState.nspanel = {
            ...nsState.nspanel,
            ac: data.ac || nsState.nspanel.ac,
            acTemp: data.acTemp || nsState.nspanel.acTemp,
            vent: data.vent || nsState.nspanel.vent,
        };
    },
    // optimistic change applied before the server confirms
    NSPANEL_AC_PATCH(nsState, patch)
    {
        nsState.nspanel = {
            ...nsState.nspanel,
            ac: { ...nsState.nspanel.ac, ...patch },
        };
    },
    // pushed by the 'module' socket event - refresh the entity inside the rooms
    NSPANEL_MODULE(nsState, module)
    {
        // the sensor cards read a whole module row, and that is exactly what this
        // event carries, so they stay live without refetching the page state
        for (const key of ['weatherStations', 'indoorSensors'])
        {
            const list = nsState.nspanel[key];

            if (!Array.isArray(list))
            {
                continue;
            }

            const index = list.findIndex((one) => one.moduleId === module.moduleId);

            if (index !== -1)
            {
                const replaced = list.slice();

                replaced[index] = module;
                nsState.nspanel = { ...nsState.nspanel, [key]: replaced };
            }
        }

        for (const room of nsState.nspanel.rooms)
        {
            if (room.moduleId === module.moduleId)
            {
                room.temperature = module.temperature;
                room.heating = (module.secRelayStatus === 1);
            }

            if (room.ventDamper != null && room.ventDamper.moduleId === module.moduleId)
            {
                room.ventDamper.open = (module.relayStatus === 1);
            }

            for (const page of room.pages)
            {
                for (const entity of page.entities)
                {
                    if (entity.moduleId === module.moduleId)
                    {
                        entity.on = (module.relayStatus === 1);
                    }
                }
            }
        }
    },
};

export default {
    state,
    getters,
    actions,
    mutations,
};
